import React from 'react';
import Hero from '../Components/Hero/Hero';
import Contact from '../Components/Contact/Contact';
import Department from '../Components/Department/Department';
import About from '../Components/About/About';
import Iconbox from '../Components/Iconbox/Iconbox';
import BrandSlider from '../Components/Slider/BrandSlider';
import Accordion from '../Components/Accordion/Accordion';
import SEO from '../Components/SEO/SEO';
import { useLanguage } from '../contexts/LanguageContext';

const heroData = {
  bgImg: 'images/hero-bg.jpg',
  bgShape: 'shape/hero-shape.png',
  sliderImages: [
    {
      img: 'images/hero-img.png',
    },
    {
      img: 'images/hero-img1.png',
    },
    {
      img: 'images/hero-img2.png',
    },
    {
      img: 'images/hero-img.png',
    },
    {
      img: 'images/hero-img1.png',
    },
    {
      img: 'images/hero-img2.png',
    },
  ],
  title: ['Crutches', 'Laboratory', 'Cardiology', 'Dentist', 'Neurology'],
};




// const beforeAfterData = {
//   bgImg: '/images/before-after-bg.jpg',
//   beforeImg: '/images/after.jpg',
//   afterImg: 'images/before.jpg',
// };





const brandData = [
  {
    bg: 'orange',
    img: 'images/startpunkt-logo.svg',
  }
  // {
  //   bg: 'green',
  //   img: 'images/smahh-logo.png',
  // },
  // {
  //   bg: 'dip-blue',
  //   img: 'images/jds-logo.png',
  // }
];

const Home = () => {
  const { t } = useLanguage();

  // Create localized data objects
  const localizedHeroData = {
    ...heroData,
    title: t('hero.titles'),
  };

  const localizedIconboxData = [
    {
      bg: 'purple',
      icon: 'icons/icon1.svg',
      title: t('iconbox.shareAppointments.title'),
      subTitle: t('iconbox.shareAppointments.subtitle'),
    },
    {
      bg: 'green',
      icon: 'icons/icon2.svg',
      title: t('iconbox.realTimeAvailability.title'),
      subTitle: t('iconbox.realTimeAvailability.subtitle'),
    },
    {
      bg: 'red',
      icon: 'icons/icon3.svg',
      title: t('iconbox.supportWhenNeeded.title'),
      subTitle: t('iconbox.supportWhenNeeded.subtitle'),
    },
  ];

  const localizedAboutData = {
    title: t('about.title'),
    subTitle: t('about.subtitle'),
    avater: {
      img: 'images/avatar1.png',
      name: t('about.founder.name'),
      designation: t('about.founder.designation'),
    },
    highlights: t('about.highlights').map(text => ({ text })),
    contact: t('about.contact'),
  };

  const localizedTeamData = [
    {
      img: 'images/feryal.jpeg',
      name: t('team.feryal.name'),
      designation: t('team.feryal.designation'),
      authorLink: '/team/feryal-catoglu',
    },
    {
      img: 'images/faheem.jpg',
      name: t('team.faheem.name'),
      designation: t('team.faheem.designation'),
      authorLink: '/team/faheem-babar',
    },
    {
      img: 'images/haitham-el-euch.jpg',
      name: t('team.haitham.name'),
      designation: t('team.haitham.designation'),
      authorLink: '/team/haitham-el-euch',
    },
    {
      img: 'images/jouhaina-salsabil-el-euch.jpg',
      name: t('team.jouhaina.name'),
      designation: t('team.jouhaina.designation'),
      authorLink: '/team/jouhaina-el-euch',
    },
  ];

  const localizedFaqData = {
    title: t('faq.title'),
    img: 'images/faq-img.png',
    bgImg: 'shape/faq-bg.svg',
    faqItems: [
      {
        title: t('faq.questions.whatIsTerminTeiler.title'),
        content: t('faq.questions.whatIsTerminTeiler.content'),
      },
      {
        title: t('faq.questions.howDoesItWork.title'),
        content: t('faq.questions.howDoesItWork.content'),
      },
      {
        title: t('faq.questions.whoCanUse.title'),
        content: t('faq.questions.whoCanUse.content'),
      },
      {
        title: t('faq.questions.isItSecure.title'),
        content: t('faq.questions.isItSecure.content'),
      },
      {
        title: t('faq.questions.unclaimedAppointment.title'),
        content: t('faq.questions.unclaimedAppointment.content'),
      },
      {
        title: t('faq.questions.practicesInsurers.title'),
        content: t('faq.questions.practicesInsurers.content'),
      },
      {
        title: t('faq.questions.whenWillLaunch.title'),
        content: t('faq.questions.whenWillLaunch.content'),
      },
      {
        title: t('faq.questions.ideaProtection.title'),
        content: t('faq.questions.ideaProtection.content'),
      },
    ],
  };

  return (
    <>
      <SEO
        title={t('seo.home.title') || 'TerminTeiler - Share Doctor Appointments | Reduce Waiting Times'}
        description={t('hero.subtitle') || t('seo.home.description')}
        keywords={t('seo.home.keywords')}
        image="/images/hero-img.png"
      />
      <Hero data={localizedHeroData} />
      <Iconbox data={localizedIconboxData} />
      <Department />
      <hr />
      {/* <TestimonialSlider data={localizedTestimonialData} /> */}
      {/* <Funfact /> */}
      <Accordion data={localizedFaqData} />
      {/* <Newsletter data={localizedNewsletterData} /> */}
      <BrandSlider data={brandData} />
      <About data={localizedAboutData} teamData={localizedTeamData} />
      <Contact />
      {/* <LocationInMap data={mapLocationURL} /> */}
    </>
  );
};

export default Home;
